import Club1 from '../media/club1.png';
import Club2 from '../media/club2.png';
import Club3 from '../media/club3.png';
import Club4 from '../media/club4.png';
import Club5 from '../media/club5.png';
import Club6 from '../media/club6.png';
import Club7 from '../media/club7.png';

export const ClubImages = [Club1, Club2, Club3, Club4, Club5, Club6, Club7];
